import React from "react";
import { Route, Routes } from "react-router-dom";
import WorkspaceMain from "./workspace/workspaceMain";
import LectureRoomMain from "./lectureRoom/lectureRoomMain";
import TelehealthMain from "./telehealth/telehealthMain";
import NotFound from "pages/common/notFound";
import Reception from "./workspace/detail/reception";
import Hotdesk from "./workspace/detail/hotdesk";
import Videoconference from "./workspace/detail/videoconference";
import Conference from "./workspace/detail/conference";

/**
 * 파일명: Space.js
 * 작성자: 강연승
 * 작성일자: 25.02.06
 * 설명: 하이브리스 스마트 스페이스 라우터
 */

function Space() {
  return (
    <Routes>
      <Route path="work/*" element={<WorkspaceMain />} />
      <Route path="room/*" element={<LectureRoomMain />} />
      <Route path="telehealth/*" element={<TelehealthMain />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
export default Space;
